<template>
    <v-card>
        <v-card-title class="accent white--text title">
            Latest Cooling Load Forecast
            <v-spacer></v-spacer>
            <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
              <v-icon>fa-info</v-icon>
            </v-btn>
            <cooling-load-explanation ref="explanationDialog"></cooling-load-explanation>
        </v-card-title>
        <v-card-text v-if="loading">
            <loading-progress-bar :loading="loading"></loading-progress-bar>
        </v-card-text>
        <v-card-text v-if="!loading">
            <v-layout>
                <v-flex xs12>
                    Forecast:

                    <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>
                </v-flex>

            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import LoadingProgressBar from '../LoadingProgressBar'
import CoolingLoadExplanation from '@/components/CoolingLoadExplanation'
import {getResult} from '@/helper'
  export default {
    name: 'CoolingLoadForecastCore',
    components: { CoolingLoadExplanation, LoadingProgressBar, VuePlotly },
    data () {
      return {
        loading: true,
        data: [
          {
            x: [0,1,2,3],
            y: [0,1,2,3],
            type: 'line',
            mode: 'lines+markers'
          }
        ],

        options: {},
        startDate: '',
        endDate: ''
      }
    },
    computed: {
      layout () {
        return {
          title: 'Cooling Load Forecast',
          hovermode: 'closest',
          xaxis: {
            title: 'Time ',
            range: [this.startDate, this.endDate],
          },
          yaxis: {
            title: 'Cooling Load (kW)'
          },
        }
      }
    },
    props: {
      content: {type: Object, default: null},
      start: {type: Number, default: 4*12},
      end: {type: Number, default: 8}
    },
    watch: {
      content() {
        this.refresh()
      }
    },
    methods: {
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async refresh () {
        if (this.content == null) {
          // no cooling load prediction result
          return null
        }


        let actualdata = this.content['df']
        let newdata = this.content['forecast']


        let cutpoint = actualdata.timestamp.length
        let endpoint = newdata.timestamp.length

        this.startDate = actualdata.timestamp[cutpoint-this.start]
        this.endDate = newdata.timestamp[cutpoint+this.end]


        this.data = [
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 0.1,
              opacity: 0.1
            },
            name: '95% Confidence Interval',
            x: newdata.timestamp,
            y: newdata.yhat_lower,
            type: 'scatter',
            mode: 'lines',
            showlegend: false
          },
          {
            line: {
              color: 'rgb(102,178,255)',
              shape: 'spline',
              width: 0.1,
              opacity: 0.1
            },
            name: '95% Confidence Interval',
            x: newdata.timestamp,
            y: newdata.yhat_upper,
            type: 'scatter',
            mode: 'lines',
            fill: 'tonexty'
          },

          {
            marker: {
              color: 'rgb(0,0,0)',
              opacity: 0.3
            },
            x: actualdata.timestamp,
            y: actualdata.total_CL,
            name: 'Actual observed value',
            type: 'scatter',
            mode: 'markers'
          },
          {
            line: {
              color: 'rgb(0,76,255)',
              shape: 'spline',
              width: 1,
              opacity: 0.9
            },
            x: newdata.timestamp.slice(0, cutpoint),
            y: newdata.yhat.slice(0, cutpoint),
            name: 'Fitted value',
            type: 'scatter',
            mode: 'lines'
          },
          {
            line: {
              color: 'rgb(255,76,76)',
              shape: 'spline',
              width: 1,
              opacity: 0.9
            },
            x: newdata.timestamp.slice(cutpoint-1, endpoint),
            y: newdata.yhat.slice(cutpoint-1, endpoint),
            name: 'Expected value',
            type: 'scatter',
            mode: 'lines'
          },
          ]
        this.loading=false
      }
    }

  }
</script>

<style scoped>

</style>
